import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Account } from '@model';
import { GenericOldService } from './generic-old.service';

const ACCOUNTS_ENDPOINT = 'accounts';

@Injectable()
export class AccountService {
  private accounts$: Observable<Account[]>;
  private _accounts: Account[];

  get accounts(): Account[] {
    return this._accounts;
  }

  constructor(private resourceService: GenericOldService<Record<string, Account>>) {}

  getAccounts(): Observable<Account[]> {
    if (!this.accounts$ && !this._accounts) {
      this.accounts$ = this.resourceService.get(ACCOUNTS_ENDPOINT).pipe(
        map(value => {
          this._accounts = Object.values(value);
          return this._accounts;
        }),
        shareReplay(1),
      );
    }
    return this.accounts$;
  }
}
